import { ObjectFieldTemplateProps } from "@rjsf/utils";
import { t } from "i18next";

function ConfigurationFormTemplate(props: ObjectFieldTemplateProps) {
  
  return (
    renderForm(props)
  );
}

function renderForm(props: ObjectFieldTemplateProps) {
  
  return (
    <>
      <div className="cms-section">
        <div className="h3">
          {t("order_data")}
        </div>
        <div className="row">
          <div className="col-6">
            <div className="row">
              <div className="col-6">
                <div className="property-wrapper">
                  {getPropertyByName("sales_commission", props)?.content}
                </div>
              </div>
              <div className="col-6">
                <div className="property-wrapper">
                  {getPropertyByName("tax_sales_commission", props)?.content}
                </div>
              </div>
              <div className="col-6">
                <div className="property-wrapper">
                  {getPropertyByName("shipments", props)?.content}
                </div>
              </div>
              <div className="col-6">
                <div className="property-wrapper">
                  {getPropertyByName("tax_shipments", props)?.content}
                </div>
              </div>
              <div className="col-6">
                <div className="property-wrapper">
                  {getPropertyByName("shipping_minimum", props)?.content}
                </div>
              </div>
              <div className="col-6">
                <div className="property-wrapper">
                  {getPropertyByName("shipping_maximum", props)?.content}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="h3 mt-3">
          {t("website_data")}
        </div>
        <div className="row">
          <div className="col-6">
            <div className="row">
              <div className="col-6">
                <div className="property-wrapper">
                  {getPropertyByName("address", props)?.content}
                </div>
              </div>
              <div className="col-6">
                <div className="property-wrapper">
                  {getPropertyByName("phone", props)?.content}
                </div>
              </div>
              <div className="col-6">
                <div className="property-wrapper">
                  {getPropertyByName("email", props)?.content}
                </div>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </>
  );
}



function getPropertyByName(name: string, props: ObjectFieldTemplateProps) {
  let element = props.properties.find((element: any) => element.name == name);
  // console.log(element);
  return element;
}

export default ConfigurationFormTemplate;
